// 此种布局包含了 footer，用于非交易页面

import React, { Suspense, ReactNode } from 'react';
import Header from '@/components/header';
import Footer from '@/components/footer';
import cx from 'classnames';
import cs from './index.module.scss';
import FullPageLoading from '@/components/fullPageLoading';
import { isFromMobile } from '@/utils/location';
import device from '@/utils/device';

interface Props {
  children: ReactNode;
  transparent?: boolean;
}

const PageLayout: React.FC<Props> = ({ children, transparent }) => (
  <div className={cx('custom-scrollbar layout-container', cs.container)}>
    <Header/>
    <div className={cx('content', cs.content, transparent ? cs.transparent : '')}>
      <Suspense fallback={<FullPageLoading />}>{children}</Suspense>
    </div>
    {!(isFromMobile() || !device.desktop()) && <Footer />}
  </div>
);

export default PageLayout;
